import { Person } from "./types";
import { Area } from "../../useAreas/areas/types";

const data: Person = {
  id: "kathrin-freist",
  firstname: "Kathrin",
  lastname: "Freist",
  title: "Rechtsanwältin",
  subtitle: "Rechtsanwältin LL.M. Informationsrecht",
  description: "",
  areas: [Area.MIETUNDWOHNUNGSEIGENTUMSRECHT],
  subAreas: [
    Area.MIETUNDWOHNUNGSEIGENTUMSRECHT,
    Area.GEWERBLICHERRECHTSSCHUTZUNDURHEBERRECHT,
    Area.ERBRECHT,
  ],
  phone: "030 / 75 79 64 0",
  mail: "kathrin.freist@wilms.eu",
  location: "",
  vita: [
    "Geboren 1981 in Berlin",
    "Studium in Berlin",
    "Referendariat beim Oberlandesgericht Düsseldorf",
    "Masterstudiengang Informationsrecht an der Heinrich-Heine-Universität Düsseldorf",
    "Rechtsanwältin seit 2011",
  ],
  memberships: [
    'Arbeitsgemeinschaft "Mietrecht und Immobilien" des Deutschen Anwaltsvereins',
  ],
};

export default data;
